import { motion } from 'framer-motion';

// Контейнер: запускает появление детей каскадом (по очереди).
export const revealContainer = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.07, delayChildren: 0.04 },
  },
};

// Элемент: лёгкое появление снизу вверх с прозрачностью.
export const revealItem = {
  hidden: { opacity: 0, y: 16 },
  show: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 320, damping: 26 },
  },
};

// Обёртка-группа: ставится на контейнер, внутри — <Reveal> на каждый блок.
export function RevealGroup({ children, style, ...rest }) {
  return (
    <motion.div
      variants={revealContainer}
      initial="hidden"
      animate="show"
      style={style}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

// Один анимируемый блок. По умолчанию — div на всю ширину.
export function Reveal({ children, style, ...rest }) {
  return (
    <motion.div variants={revealItem} style={{ width: '100%', ...style }} {...rest}>
      {children}
    </motion.div>
  );
}

export default Reveal;